import React from 'react';
import Alert from '@mui/material/Alert'

import { useDataProviderState, useDataProviderActions } from '../../providers/DataProvider';

export default function AlertMessage() {

    const { errorMessage, successMessage } = useDataProviderState();
    const { clearMessage } = useDataProviderActions();

    if (!errorMessage && !successMessage) return null;

    return (
        <Alert severity={errorMessage ? 'error' : 'success'} onClose={() => clearMessage()}>
            {errorMessage || successMessage}
        </Alert>
    )
}
